module.exports = __webpack_public_path__ + "themify.2c454669bdf3aebf32a1.eot";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/themify-icons/fonts/themify.eot?-fvbane
// module id = ../../../../../src/assets/scss/icons/themify-icons/fonts/themify.eot?-fvbane
// module chunks = styles